import * as Sentry from "@sentry/react";

export function logInfo(message: string, extra: any = {}) {
  console.log(message);
  Sentry.captureMessage(message, {
    level: "info",
    extra,
  });
}

/**
 * Capture an error to Sentry with a human-readable context message.
 *
 * Pass the original Error/unknown caught value as the second argument so
 * Sentry preserves its real type (e.g. `FirebaseError: internal`) and stack.
 * Strings are still accepted for backward compatibility, but lose stack info.
 */
export function logError(message: string, error?: unknown) {
  console.error(message, error);

  const exception = error instanceof Error ? error : new Error(message);
  // Group by `message` so different call sites stay in distinct Sentry issues
  // even when they share the same underlying Error type/message.
  Sentry.captureException(exception, {
    fingerprint: ["{{ default }}", message],
    tags: { errorContext: message.slice(0, 200) },
    extra:
      error instanceof Error ? { errorContext: message } : { errorContext: message, detail: error },
  });
}
